import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EnquiryStateService {
  private enquiryShownSubject = new BehaviorSubject<boolean>(false);
  private enquirySubmittedSubject = new BehaviorSubject<boolean>(false);

  constructor() {
    // Check if user has already submitted enquiry (check cookie)
    this.enquirySubmittedSubject.next(this.hasEnquiryCookie());
  }

  /**
   * Check if the enquiry form has already been shown in current session
   */
  hasEnquiryBeenShown(): boolean {
    return this.enquiryShownSubject.value;
  }

  /**
   * Mark that the enquiry form has been shown
   */
  markEnquiryAsShown(): void {
    this.enquiryShownSubject.next(true);
  }

  /**
   * Check if user has already submitted an enquiry (via cookie)
   */
  hasEnquiryBeenSubmitted(): boolean {
    return this.enquirySubmittedSubject.value || this.hasEnquiryCookie();
  }

  /**
   * Mark that user has submitted the enquiry
   */
  markEnquiryAsSubmitted(): void {
    this.enquirySubmittedSubject.next(true);
  }

  /**
   * Reset the enquiry shown state (useful for testing or specific scenarios)
   */
  resetEnquiryShownState(): void {
    this.enquiryShownSubject.next(false);
  }

  /**
   * Check if the enquiry cookie exists
   */
  private hasEnquiryCookie(): boolean {
    return document.cookie.split(';').some((item) => item.trim().startsWith('Username='));
  }

  /**
   * Observable to track enquiry submission state
   */
  getEnquirySubmittedObservable(): Observable<boolean> {
    return this.enquirySubmittedSubject.asObservable();
  }
}
